/**
 * @module ToggleLabelsControl
 */
import "./ToggleLabelsControl.css";
import Control from 'ol/control/Control';
import { getLayerByName } from '../utils/getLayerByName.js';

class ToggleLabelsControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'nhc-map-toggle-labels border-top border-gray-10 padding-y-1 padding-x-2';

    container.innerHTML = `
      <fieldset class="usa-fieldset padding-bottom-2px">
        <legend class="usa-legend usa-legend text-bold">Select map label size</legend>
        <div class="usa-radio">
          <input
            class="usa-radio__input"
            id="smaller-labels"
            type="radio"
            name="label-size"
            value="smaller-labels"
            checked="checked"
          />
          <label class="usa-radio__label" for="smaller-labels"
            >Smaller labels</label
          >
        </div>
        <div class="usa-radio">
          <input
            class="usa-radio__input"
            id="larger-labels"
            type="radio"
            name="label-size"
            value="larger-labels"
          />
          <label class="usa-radio__label" for="larger-labels"
            >Larger labels</label
          >
        </div>
      </fieldset>
    `;

    super({
      element: container,
      target: options.target
    });

    // Store the map object
    this.map = options.map;

    // Event handler for label-size radio buttons
    const radioButtons = container.querySelectorAll('input[name="label-size"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        const selectedSize = container.querySelector('input[name="label-size"]:checked').value;
        const stateAbbrLayerLg = getLayerByName(this.map, 'stateAbbrLayerLg');
        const stateAbbrLayerSm = getLayerByName(this.map, 'stateAbbrLayerSm');
        const nhcLabelLayerLg = getLayerByName(this.map, 'nhcLabelLayerLg');
        const nhcLabelLayerSm = getLayerByName(this.map, 'nhcLabelLayerSm');
        if (selectedSize === 'smaller-labels') {
          nhcLabelLayerLg.setVisible(false);
          if (stateAbbrLayerLg) stateAbbrLayerLg.setVisible(false);
          if (stateAbbrLayerSm) stateAbbrLayerSm.setVisible(true);
          nhcLabelLayerSm.setVisible(true);
        } else {
          nhcLabelLayerLg.setVisible(true);
          if (stateAbbrLayerLg) stateAbbrLayerLg.setVisible(true);
          if (stateAbbrLayerSm) stateAbbrLayerSm.setVisible(false);
          nhcLabelLayerSm.setVisible(false);
        }
      });
    });

  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
  }

}

export default ToggleLabelsControl;